import React, {useEffect, useState} from 'react'
import {Pagination} from '../../../../components/Pagination'
import {useHistory} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'
import {bindActionCreators} from 'redux'
import {State} from '../../../../reducers'
import {Tooltip} from '@mui/material'
import FilterButton from '../../../../components/Tables/TableComponent/FilterButton'
import {
  gc_lc_OpenModalEliminarCliente,
  gc_lc_OpenModalEstatus,
  gc_lc_SetClienteSeleccionado,
} from '../../../../actions/gestion-cliente/lista-cliente/listaCliente.actions'
import {actionsGCListarClientes, actionsGCEditarCliente} from '../../../../actions/action-creators'
import Edit from '../../../../media/felsv/DarkEditPencil.svg'
import Recycle from '../../../../media/felsv/DarkRecycleDelete.svg'
import Open_Eye from '../../../../media/felsv/Open_Eye.svg'
import Close_Eye from '../../../../media/felsv/Close_Eye.svg'
import DarkDocumentCheck from '../../../../media/felsv/DarkDocumentCheck.svg'
import '../styles/table-list-cliente.css'

const TableListCliente = () => {
  const [currentItems, setCurrentItems] = useState<any[]>([])
  const [sortedData, setSortedData] = useState<any[]>([])

  const clientes = useSelector((state: State) => state.gestionCliente.listarClientes.clientes)
  const formClientes = useSelector((state: State) => state.gestionCliente.listarClientes.formBuscar)

  const history = useHistory()
  const dispatch = useDispatch()
  const acciones = bindActionCreators(actionsGCListarClientes, dispatch)
  const actionsEditar = bindActionCreators(actionsGCEditarCliente, dispatch)

  const filtrarClientes = () => {
    return clientes.filter((c) => {
      const nombre = c.nombre?.toLowerCase() ?? ''
      const email = c.email?.toLowerCase() ?? ''
      const telefono = c.telefono ?? ''
      const numId = c.numId?.toLowerCase() ?? ''

      const filtroNombre = formClientes.nombre
        ? nombre.includes(formClientes.nombre.toLowerCase())
        : true

      const filtroEmail = formClientes.email
        ? email.includes(formClientes.email.toLowerCase())
        : true

      const filtroTelefono = formClientes.telefono ? telefono.includes(formClientes.telefono) : true

      const filtroNumId = formClientes.numId
        ? numId.includes(formClientes.numId.toLowerCase())
        : true

      const filtroTipoDoc = formClientes.tipoDocumento
        ? c.tipoDocumento?.toString() === formClientes.tipoDocumento
        : true

      return filtroNombre && filtroEmail && filtroTelefono && filtroNumId && filtroTipoDoc
    })
  }

  // Actualizar datos filtrados
  useEffect(() => {
    setSortedData(filtrarClientes())
  }, [clientes, formClientes])

  // GetClientes ya se llama en ListaCliente.page al montar

  const seleccionarCliente = (cliente: any) => dispatch(gc_lc_SetClienteSeleccionado(cliente))

  const clicEliminarCliente = (cliente: any) => {
    seleccionarCliente(cliente)
    dispatch(gc_lc_OpenModalEliminarCliente(true))
  }

  const clicEditarCliente = async (cliente: any) => {
    await actionsEditar.gc_ec_OpenEditar(cliente)
    history.push('/gestion-clientes/editar-cliente')
  }

  const clicControlActivarCliente = (cliente: any, accion: boolean) => {
    dispatch(gc_lc_SetClienteSeleccionado({...cliente, accionEstatus: accion}))
    dispatch(gc_lc_OpenModalEstatus(true))
  }

  return (
    <div className='container-white w-100' style={{overflowX: 'auto'}}>
      <h4 className='h4-titles'>Resultados obtenidos</h4>
      <div className='tab-plane mt-16' style={{overflowX: 'auto'}}>
        <table className='tlu-table-main-responsive tlu-responsive-table-main td-left table-pointer'>
          <thead>
            <tr>
              <td>Acciones</td>
              <td>
                Tipo de documento{' '}
                <FilterButton
                  data={sortedData}
                  keyName='nombreTipoDocumento'
                  state={setSortedData}
                />
              </td>
              <td>
                Nº Documento{' '}
                <FilterButton data={sortedData} keyName='numId' state={setSortedData} />
              </td>
              <td>
                Nombre <FilterButton data={sortedData} keyName='nombre' state={setSortedData} />
              </td>
              <td>
                Email <FilterButton data={sortedData} keyName='email' state={setSortedData} />
              </td>
              <td>
                Teléfono <FilterButton data={sortedData} keyName='telefono' state={setSortedData} />
              </td>
              <td>
                Departamento{' '}
                <FilterButton
                  data={sortedData}
                  keyName='nombreDepartamento'
                  state={setSortedData}
                />
              </td>
              <td>
                Municipio{' '}
                <FilterButton data={sortedData} keyName='nombreMunicipio' state={setSortedData} />
              </td>
              <td>
                Estado <FilterButton data={sortedData} keyName='activo' state={setSortedData} />
              </td>
              <td>
                Actividad Económica
                {' '}
                <FilterButton data={sortedData} keyName='descripcion' state={setSortedData} />
              </td>
              <td>
                Fecha Creación
                {' '}
                <FilterButton data={sortedData} keyName='fechaCreacion' state={setSortedData} />
              </td>
            </tr>
          </thead>
          <tbody>
            {sortedData.length === 0 ? (
              <tr>
                <td
                  colSpan={11}
                  style={{textAlign: 'center', fontWeight: 500, fontSize: 20, padding: '1%'}}
                >
                  Sin datos disponibles.
                </td>
              </tr>
            ) : (
              currentItems.map((cliente, index) => (
                <tr key={index} style={{cursor: 'pointer'}}>
                  <td data-label='Acciones' className='table-td'>
                    {cliente?.activo !== 'Activo' && (
                      <Tooltip title='Eliminar cliente' arrow>
                        <button
                          className='table-action'
                          onClick={(e) => {
                            e.stopPropagation()
                            clicEliminarCliente(cliente)
                          }}
                        >
                          <img src={Recycle} alt='Eliminar Cliente' className='table-img-action' />
                        </button>
                      </Tooltip>
                    )}
                    <Tooltip title={cliente?.activo === 'Activo' ? 'Desactivar' : 'Activar'} arrow>
                      <button
                        className='table-action'
                        onClick={(e) => {
                          e.stopPropagation()
                          clicControlActivarCliente(cliente, cliente?.activo === 'Activo')
                        }}
                      >
                        <img
                          src={cliente?.activo === 'Activo' ? Open_Eye : Close_Eye}
                          alt='Estado Cliente'
                          className='table-img-action'
                        />
                      </button>
                    </Tooltip>
                    {cliente?.activo === 'Activo' && (
                      <Tooltip title='Editar cliente' arrow>
                        <button
                          className='table-action'
                          onClick={(e) => {
                            e.stopPropagation()
                            clicEditarCliente(cliente)
                          }}
                        >
                          <img src={Edit} alt='Editar Cliente' className='table-img-action' />
                        </button>
                      </Tooltip>
                    )}
                    <Tooltip title='Ver documentos' arrow>
                      <button
                        className='table-action'
                        onClick={(e) => {
                          e.stopPropagation()
                          history.push('/gestion-clientes/documentos-cliente', {cliente})
                        }}
                      >
                        <img src={DarkDocumentCheck} alt='Ver documentos' className='table-img-action' />
                      </button>
                    </Tooltip>
                  </td>
                  <td data-label='Tipo Documento'>{cliente?.nombreTipoDocumento ?? '---'}</td>
                  <td data-label='Nº Documento'>{cliente?.numId ?? '---'}</td>
                  <td data-label='Nombre'>
                    <Tooltip title={cliente?.nombre || ''} arrow>
                      <span className='descripcion-celda'>
                        {cliente?.nombre?.length > 40
                          ? cliente.nombre.slice(0, 40) + '...'
                          : cliente.nombre}
                      </span>
                    </Tooltip>
                  </td>
                  <td data-label='Email'>
                    <Tooltip title={cliente?.email || ''} arrow>
                      <span className='descripcion-celda'>
                        {cliente?.email ? cliente.email.split(',')[0].trim() : '---'}
                      </span>
                    </Tooltip>
                  </td>
                  <td data-label='Teléfono'>{cliente?.telefono ?? '---'}</td>
                  <td data-label='Departamento'>{cliente?.nombreDepartamento ?? '---'}</td>
                  <td data-label='Municipio'>{cliente?.nombreMunicipio ?? '---'}</td>
                  <td data-label='Estado'>
                    <div style={{justifyContent: 'center', width: '100%', display: 'flex'}}>
                      <div
                        className={`lista-cliente-estado-${
                          cliente?.activo === 'Activo' ? 'activo' : 'inactivo'
                        }`}
                      >
                        {cliente?.activo ?? '---'}
                      </div>
                    </div>
                  </td>
                  <td data-label='Actividad Económica'>
                    <Tooltip
                      title={`${cliente?.actividad ?? ''} - ${cliente?.descripcion ?? ''}`}
                      arrow
                    >
                      <span className='descripcion-celda'>
                        {cliente?.actividad && cliente?.descripcion
                          ? `${cliente.actividad} - ${cliente.descripcion}`
                          : cliente?.actividad ?? '---'}
                      </span>
                    </Tooltip>
                  </td>
                  <td data-label='Fecha Creación'>{cliente?.fechaCreacion ?? '---'}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
        <Pagination data={sortedData} state={setCurrentItems} items={15} />
      </div>
    </div>
  )
}

export default TableListCliente
